// CustomChipsInput.js
import React from 'react';
import { styled } from '@mui/material/styles';
import { MuiChipsInput } from 'mui-chips-input';

const StyledChipsInput = styled(MuiChipsInput)(({ theme }) => ({
  // Container styles

  '& .MuiOutlinedInput-root': {
    borderRadius: 0,

    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: '1px solid rgba(0, 0, 0, 0.23)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #1e1e1e',
    },
  },

  // Chip styles
  '& .MuiChip-root': {
    fontWeight: 500,
    fontFamily: 'Akkurat_Bold',
  },
}));

const CustomChipsInput = ({ placeholder, value, onChange }) => {
  return (
    <StyledChipsInput
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      fullWidth
    />
  );
};

export default CustomChipsInput;
